// Audit-driven addition #3: ImpersonationBanner — sticky non-dismissible
// yellow stripe rendered when access.impersonator_id is set.
// "End impersonation" calls POST /api/admin/end-impersonation (V2 endpoint;
// V1 button is wired but the endpoint 404s — that's expected until Plan 6).

import { ShieldAlert } from "lucide-react";
import { useAccess } from "@/auth/AccessContext";

export function ImpersonationBanner() {
  const { access } = useAccess();
  if (!access?.impersonator_id) return null;

  const endImpersonation = async () => {
    try {
      await fetch("/api/admin/end-impersonation", {
        method: "POST",
        credentials: "same-origin",
      });
    } finally {
      window.location.href = "/dashboard";
    }
  };

  return (
    <div
      role="alert"
      className="sticky top-0 z-30 bg-amber-200 border-b border-amber-400 px-4 py-2 flex items-center gap-2 text-sm text-amber-900"
    >
      <ShieldAlert size={16} />
      <span className="flex-1">
        You are impersonating another user. Actions taken here are logged.
      </span>
      <button
        onClick={() => void endImpersonation()}
        className="text-xs px-2 py-1 bg-amber-900 text-amber-50 rounded hover:bg-amber-800"
      >
        End impersonation
      </button>
    </div>
  );
}
